(function () {
  function initProductTotalPrice() {
    var productJson = document.querySelector('script[id^="ProductJson-"]');
    var variantSelect = document.querySelector('select[name="id"]#product-selectors');
    var quantityInput = document.querySelector('form.product-form input[name="quantity"]');
    var priceElement = document.querySelector('[id^="ProductPrice-"]');

    if (!productJson || !variantSelect || !priceElement) return;

    var product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    var activeVariant = null;

    function selectedVariant() {
      var variantId = String(variantSelect.value);
      return product.variants.find(function (variant) {
        return String(variant.id) === variantId;
      });
    }

    function quantity() {
      var value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      return Number.isFinite(value) && value > 0 ? value : 1;
    }

    function renderTotal(variantOverride) {
      var variant = variantOverride || activeVariant || selectedVariant();
      if (!variant) return;

      var totalCents = variant.price * quantity();
      var moneyFormat = window.money_format || '${{amount}}';
      priceElement.innerHTML = Shopify.formatMoney(totalCents, moneyFormat);
      priceElement.setAttribute('content', (totalCents / 100).toFixed(2));
    }

    function renderAfterThemeHandlers() {
      window.setTimeout(renderTotal, 0);
    }

    if (typeof window.selectCallback === 'function') {
      var themeSelectCallback = window.selectCallback;
      window.selectCallback = function (variant, selector) {
        themeSelectCallback(variant, selector);
        if (variant) activeVariant = variant;
        window.setTimeout(function () {
          renderTotal(variant);
        }, 0);
      };
    }

    document.addEventListener('change', function (event) {
      if (event.target === variantSelect || event.target === quantityInput || event.target.closest('.swatch')) {
        if (event.target === variantSelect) activeVariant = selectedVariant();
        renderAfterThemeHandlers();
      }
    });

    document.addEventListener('input', function (event) {
      if (event.target === quantityInput) renderAfterThemeHandlers();
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.product-form__item--quantity .items')) renderAfterThemeHandlers();
    });

    renderAfterThemeHandlers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTotalPrice);
  } else {
    initProductTotalPrice();
  }
})();
